module.exports = __webpack_public_path__ + "img/0d69b43.jpg";